import { RepositoryObjectService, Result } from '@softline/core';
import { computed, inject, Injectable, signal } from '@angular/core';
import { WeightReport } from '../types/weight-report.model';
import { ReportRepository } from '../repositories/report.repository';

@Injectable()
export class ReportService extends RepositoryObjectService<
  WeightReport,
  Result<WeightReport>,
  undefined,
  undefined
> {
  override params = computed(() => {
    return undefined;
  });

  constructor() {
    super(inject(ReportRepository), { skipInitialLoad: true });
  }

  protected override getValue(result: Result<WeightReport>): WeightReport{
    return result.result;
  }
}
